export default __webpack_public_path__ + "static/media/laban-400px.fe4fef85.png";